export const graphAuxiliaryStyles = [
  {
    selector: "node.lowDegree",
    style: {
      "display": "none"
    }
  },
  {
    selector: "node.hasPendency",
    style: {
      "border-color": "#FFC107",
      "border-width": "3px"
    }
  },
  {
    selector: "edge.lowDegree",
    style: {
      "display": "none"
    }
  }
];
